<template>
    <form class="form">
        <div class="modal-head">
            <h2 class="h2">Sounds</h2>
            <h3 class="h2 black">{{ window.t('account_your_account') }}</h3>
        </div>
        <div class="modal-body">
            <ul class="tabs">
                <li v-for="tab in tabs" :key="'tab-' + tab.id" :class="{active: activeTab == tab.id}" @click.prevent="changeTab(tab.id)">{{ tab.name }}</li>
                <li class="logout"><a href="/logout">{{ window.t('account_logout_title') }}</a></li>
            </ul>
            <div class="step">
                <template v-if="activeTab == 'info'">
                    <div v-html="window.t('account_information_body')"></div>
                </template>
                <template v-if="activeTab == 'downloads'">
                   <template v-if="downloads.length">
                       <table class="downloads-table">
                           <tbody>
                               <tr v-for="download in downloads" :key="'download-' + download.id">
                                    <td><play-button :player-id="'account-downloads-' + download.id" :file-id="download.id" :description="download.name"></play-button></td>
                                    <td><div style="transform:translateY(0.2em);">{{ download.name }}</div></td>
                                    <td> &nbsp; <a href="#" @click.prevent="downloadSound(download.id)"><img src="/images/download-red.svg" alt="download"></a></td>
                               </tr>
                           </tbody>
                       </table>
                   </template>
                   <template v-else>
                       {{ window.t('account_no_downloads') }}
                   </template>
                </template>
                <template v-else-if="activeTab == 'edit' && formData">
                    <div class="fields">
                        <div class="field w50">
                            <input type="text" name="first_name" id="first_name" :placeholder="window.t('form_first_name')+'*'" v-model="formData.first_name">
                            <span class="incorrect" v-if="errors.first_name" v-html="showError('first_name')"></span>
                        </div>
                        <div class="field w50">
                            <input type="text" name="last_name" id="last_name" :placeholder="window.t('form_first_name')+'*'" v-model="formData.last_name">
                            <span class="incorrect" v-if="errors.last_name" v-html="showError('last_name')"></span>
                        </div>
                        <div class="field w50">
                            <input type="email" name="email" id="email" :placeholder="window.t('form_email')+'*'" v-model="formData.email">
                            <span class="incorrect" v-if="errors.email" v-html="showError('email')"></span>
                        </div>
                        <div class="field w50">
                            <input type="text" name="phone" id="phone" :placeholder="window.t('form_phone')+'*'" v-model="formData.phone">
                            <span class="incorrect" v-if="errors.phone" v-html="showError('phone')"></span>
                        </div>
                        <div class="field w50">
                            <input type="text" name="postalcode" id="postalcode" :placeholder="window.t('form_zipcode')+'*'" v-model="formData.postalcode">
                            <span class="incorrect" v-if="errors.postalcode" v-html="showError('postalcode')"></span>
                        </div>
                        <div class="field w50">
                            <select v-model="formData.country">
                                <option v-for="country in countries" :key="'country-select-' + country.code" :value="country.code">{{ country.name }}</option>
                            </select>
                            <span class="incorrect" v-if="errors.country" v-html="showError('first_name')"></span>
                        </div>
                        <div class="field w100">
                            <input type="text" name="address1" id="address1" :placeholder="window.t('form_address_1')" v-model="formData.address1">
                            <span class="incorrect" v-if="errors.address1" v-html="showError('address1')"></span>
                        </div>
                        <div class="field w100">
                            <input type="text" name="address2" id="address2" :placeholder="window.t('form_address_2')" v-model="formData.address2">
                            <span class="incorrect" v-if="errors.address2" v-html="showError('address2')"></span>
                        </div>
                        <div class="field w50">
                            <input type="text" name="company" id="company" :placeholder="window.t('form_company')" v-model="formData.company">
                            <span class="incorrect" v-if="errors.company" v-html="showError('company')"></span>
                        </div>
                        <div class="field w50">
                            <input type="text" name="vat_number" id="vat_number" :placeholder="window.t('form_vat')" v-model="formData.vat_number">
                            <span class="incorrect" v-if="errors.vat_number" v-html="showError('vat_number')"></span>
                        </div>
                        <div class="field w100">
                            <label><input type="checkbox" name="change_password" v-model="formData.change_password" value="1" style="display:inline-block; margin-right:0.2em; transform:translateY(2px);"> {{ window.t('account_change_password') }}</label>
                        </div>
                        <template v-if="formData.change_password">
                            <div class="field w50">
                                <input type="password" name="current_password" id="current_password" :placeholder="window.t('form_your_current_password')" v-model="formData.current_password">
                                <span class="incorrect" v-if="errors.current_password" v-html="showError('current_password')"></span>
                            </div>
                            <div class="field w50">
                                &nbsp;
                            </div>
                            <div class="field w50">
                                <input type="password" name="password" id="password" :placeholder="window.t('form_new_password')" v-model="formData.password">
                                <span class="incorrect" v-if="errors.password" v-html="showError('password')"></span>
                            </div>
                            <div class="field w50">
                                <input type="password" name="password_confirmation" id="password_confirmation" :placeholder="window.t('form_new_password_confirm')" v-model="formData.password_confirmation">
                                <span class="incorrect" v-if="errors.password_confirmation" v-html="showError('password_confirmation')"></span>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-else-if="activeTab == 'subscription' && subscriptionData">
                    <subscription :locale="locale" class="compact" @group="subscriptionData.group = $event" @option="subscriptionData.option = $event" :group="subscriptionData.group" :option="subscriptionData.option" :current-group="subscriptionData.group" :current-option="subscriptionData.option" ></subscription>
                </template>
            </div>
        </div>
        <div class="modal-foot">
            <span>&nbsp;</span>
            <a v-if="activeTab == 'edit'" href="#" class="btn w180" @click.prevent="saveData">{{ window.t('account_save') }}</a>
        </div>
    </form>
</template>
<script>
    export default {
        props: {
            locale: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                window,
                activeTab: 'info',
                isSubmitting: false,
                errors: {},
                formData: null,
                subscriptionData: null,
                countries: [],
                tabs:[
                    {
                        id: 'info',
                        name: window.t('account_information_title'),
                    },
                    {
                        id: 'downloads',
                        name: window.t('account_downloads_title'),
                    },
                    {
                        id: 'edit',
                        name: window.t('account_details_title'),
                    },
                    {
                        id: 'subscription',
                        name: window.t('account_subscription_title'),
                    },
                ],
                downloads: [],
            };
        },
        methods: {
            async changeTab(tab) {
                if (this.isSubmitting || tab == this.activeTab) {
                    return false;
                }

                if (!this.formData) {
                    this.isSubmitting = true;
                    await this.fetchData();
                    this.isSubmitting = false;
                }

                if (this.formData) {
                    this.activeTab = tab;
                }
            },
            async fetchData() {
                await axios
                    .post('/account/init')
                    .then(response => {
                        if (response.data.hasOwnProperty('formData')) {
                            this.formData = response.data.formData;
                        }

                        if (response.data.hasOwnProperty('subscriptionData')) {
                            this.subscriptionData = response.data.subscriptionData;
                        }

                        if (response.data.hasOwnProperty('countries')) {
                            this.countries = response.data.countries;
                        }

                        if (response.data.hasOwnProperty('downloads')) {
                            this.downloads = response.data.downloads;
                        }
                    })
                    .catch(error => {
                        alert('Something went wrong.');
                    });
            },
            saveData() {
                if (this.isSubmitting) {
                    return false;
                }

                this.errors = {};
                this.isSubmitting = true;

                axios
                    .post('/account', this.formData)
                    .then(response => {
                        this.formData.change_password = 0;
                        this.formData.current_password = '';
                        this.formData.password = '';
                        this.formData.password_confirmation = '';

                        alert('Account settings saved');
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        }
                    })
                    .finally(() => this.isSubmitting = false);
            },
            showError(fieldName) {
                if (!this.errors[fieldName]) {
                    return '';
                }

                return this.errors[fieldName].join('<br>');
            },
            downloadSound(id) {
                document.location = '/sounds/download/' + id;
            },
        },
        mounted() {

        },
    }
</script>
